// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__OESYu","Logo_Small":"Logo_Logo_Small__iQYAj"};